export default /* glsl */`
// #define NOISEAMP 40.
#define NOISEWIDTH 128.
#define NOISEHEIGHT 128.

uniform float uTime;
uniform sampler2D uNoiseTexture;

uniform vec3 uSize;
uniform vec3 uCenter;
uniform vec2 uSpeed;
uniform float uNoiseAmp;
uniform float uParticleSize;

attribute float progress;
varying float vOpacity;

void main() {
  vOpacity = .8;

  // vec3 positivePosition = position + uSize / 2.;

  float timeFactor = .05;

  vec3 noise = vec3(
    cnoise(vec2(position.x, uTime * timeFactor)) - .5,
    cnoise(vec2(progress, uTime * timeFactor)) - .5,
    cnoise(vec2(position.z, uTime * timeFactor)) - .5
  );

  vec3 newPosition = vec3(
    uCenter.x + mod(position.x + noise.x * uNoiseAmp + (uTime + progress) * uSpeed.x, uSize.x) - uSize.x / 2.,
    uCenter.y + mod(position.y + noise.y * uNoiseAmp + (uTime + progress) * uSpeed.y, uSize.y) - uSize.y / 2.,
    position.z + noise.z * uNoiseAmp
  );

  vec4 mvPosition = modelViewMatrix * vec4(newPosition, 1.);

  gl_PointSize = uParticleSize * (-500. / mvPosition.z);
  gl_Position = projectionMatrix * mvPosition;
}
`